export default "__VITE_ASSET__DILmID2P__"